import React from 'react'
import './css/Materials.css'
import {Layout, Table} from "antd";
import HeaderNav from "../header/header";
const { Content } = Layout;

class Materials extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            dataSource:[
                {id:'1',claimType:'PCG',market:'Benelux, Nordics',emailAddress:'northbl__cos@lenovo.com'},
                {id:'2',claimType:'PCG',market:'MEA',emailAddress:'meta_cos@lenovo.com'},
                {id:'3',claimType:'PCG',market:'UKI',emailAddress:'uki_cos@lenovo.com'},
                {id:'4',claimType:'PCG',market:'Poland, Czech/Slovakia, EECA, Russia, SEE',emailAddress:'east_cos@lenovo.com'},
                {id:'5',claimType:'PCG',market:'GAT, CH',emailAddress:'central_cos@lenovo.com'},
                {id:'6',claimType:'PCG',market:'France, Italy',emailAddress:'south_cos@lenovo.com'},
                {id:'7',claimType:'PCG',market:'Iberia',emailAddress:'iberia_cos@lenovo.com'},
                {id:'8',claimType:'DCG',market:'all markets',emailAddress:'dcg_cos_hw@lenovo.com'},
                {id:'9',claimType:'CBSO',market:'all markets',emailAddress:'cbso_finance@lenovo.com'},
                {id:'10',claimType:'Price Protection',market:'all markets',emailAddress:'ppremea@lenovo.com'},
                {id:'11',claimType:'Service & Software Cancellation',market:'all markets',emailAddress:'le_services@lenovo.com'},
                {id:'12',claimType:'Service Repair Related',market:'all markets',emailAddress:'east_servrep@lenovo.com'},
                {id:'13',claimType:'Backend Disbursement',market:'all markets',emailAddress:'bdp@lenovo.com'},
            ]
        }
        this.columns=[
            {
                title: 'Business unit/ Claim type',
                dataIndex: 'claimType',
            },
            {
                title: 'Market',
                dataIndex: 'market',
            },
            {
                title: 'Email Address',
                dataIndex: 'emailAddress',
                render:((text)=>{
                    return <a href={'mailto:'+text} target="_blank">{text}</a>
                })
            },
        ]
    }
    render() {
        const {dataSource}=this.state;
        return <div>
            <HeaderNav parmas={'/materials'}/>
            <Layout className="site-layout-background" style={{ padding: '24px 0',width: '1000px',margin: '0 auto' }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1>Useful Materials</h1>
                    <h4>Links</h4>
                    <ul className="list-box">
                        <li>
                            <span>Lenovo main page.</span>
                            <em><a target="_blank" href="http://www.lenovo.com">http://www.lenovo.com</a></em>
                        </li>
                        <li>
                            <span>Assist in all instances where the registration of a Lenovo Service was not successful. Amend Services contract information, resend registration emails to customers, cancel/credit incompatible orders for Services. Finalise and process bulk services registration files.</span>
                            <em><a target="_blank" href="http://www.lenovo.com/registrationsupport">http://www.lenovo.com/registrationsupport</a></em>
                        </li>
                    </ul>
                    <Table
                        style={{paddingRight:24}}
                        rowKey={'id'}
                        bordered
                        dataSource={dataSource}
                        columns={this.columns}
                        pagination={false}
                    />
                    <h4 style={{marginTop:"50px"}}>Hot Line Support (DOA)</h4>
                    <p>For DOA (Dead On Arrival) issues with Think Pad Western Europe (WE) please contact the technical support first:</p>
                    <ul className="list-box ">
                        <li>
                            <b>UK</b><span>: +44 333-777-3991 (Option 3), </span><a href="https://pcsupport.lenovo.com/gb/en/servicerequest">https://pcsupport.lenovo.com/gb/en/servicerequest</a>
                        </li>
                        <li>
                            <b>Ireland</b><span>: 1890- 928- 860 (Option 3), </span><a href="https://pcsupport.lenovo.com/ie/en/servicerequest">https://pcsupport.lenovo.com/ie/en/servicerequest</a>
                        </li>
                        <li>
                            <b>Spain</b><span>: +34 9179 11 799 (Option 3), </span><a href="https://pcsupport.lenovo.com/es/es/servicerequest">https://pcsupport.lenovo.com/es/es/servicerequest</a>
                        </li>
                        <li>
                            <b>Portugal</b><span>: +351 211 227 833 (Option 3), </span><a href="https://pcsupport.lenovo.com/pt/pt/servicerequest">https://pcsupport.lenovo.com/pt/pt/servicerequest</a>
                        </li>
                        <li>
                            <b>France</b><span>: +33 170 381 927 (Option 3), </span><a href="https://pcsupport.lenovo.com/fr/fr/servicerequest">https://pcsupport.lenovo.com/fr/fr/servicerequest</a>
                        </li>
                        <li>
                            <b>Italy</b><span>: +3902 303 10000 (Option 3), </span><a href="https://pcsupport.lenovo.com/it/it/servicerequest">https://pcsupport.lenovo.com/it/it/servicerequest</a>
                        </li>
                        <li>
                            <b>Germany</b><span>: +49 201 22099 888 (Option 3), </span><a href="https://pcsupport.lenovo.com/de/de/servicerequest">https://pcsupport.lenovo.com/de/de/servicerequest</a>
                        </li>
                        <li>
                            <b>Austria</b><span>: +43 19 287 666 (Option 3), </span><a href="https://pcsupport.lenovo.com/at/de/servicerequest">https://pcsupport.lenovo.com/at/de/servicerequest</a>
                        </li>
                        <li>
                            <b>Switzerland</b><span>: +41 44 798 2222 (Option 3), </span><a href="https://pcsupport.lenovo.com/ch/de/servicerequest">https://pcsupport.lenovo.com/ch/de/servicerequest</a>
                        </li>
                        <li>
                            <b>Belgium</b><span>: 02-700-73-77 (Option 3), </span><a href="https://pcsupport.lenovo.com/be/nl/servicerequest">https://pcsupport.lenovo.com/be/nl/servicerequest</a>
                        </li>
                        <li>
                            <b>Denmark</b><span>: +45 89881536 (Option 3), </span><a href="https://pcsupport.lenovo.com/dk/da/servicerequest">https://pcsupport.lenovo.com/dk/da/servicerequest</a>
                        </li>
                        <li>
                            <b>Netherlands</b><span>: +31 204 990 153 (Option 3), </span><a href="https://pcsupport.lenovo.com/nl/nl/servicerequest">https://pcsupport.lenovo.com/nl/nl/servicerequest</a>
                        </li>
                        <li>
                            <b>Finland</b><span>: +358 97 47 90 251 (Option 3), </span><a href="https://pcsupport.lenovo.com/fi/fi/servicerequest">https://pcsupport.lenovo.com/fi/fi/servicerequest</a>
                        </li>
                        <li>
                            <b>Sweden</b><span>: +46 840 30 01 81 (Option 3), </span><a href="https://pcsupport.lenovo.com/se/sv/servicerequest">https://pcsupport.lenovo.com/se/sv/servicerequest</a>
                        </li>
                        <li>
                            <b>Norway</b><span>: +47 67 204501 (Option 3), </span><a href="https://pcsupport.lenovo.com/no/nb/servicerequest">https://pcsupport.lenovo.com/no/nb/servicerequest</a>
                        </li>
                    </ul>
                </Content>
            </Layout>
        </div>

    }
}

export default Materials;